import { Detail } from './detail';
import  {List } from './list';
export const Help = {
    Detail, List
};
